// noinspection ES6UnusedImports

import React from "react";
import ReactDOM from "react-dom";
import { fetchAuthSession } from "aws-amplify/auth";
import "aws-amplify/auth/enable-oauth-listener";
import App from "components/app/App";
import { QueryClient, QueryClientProvider } from "react-query";
import { OpenAPI } from "gen/clients/llts";
import initI18n from "./i18n";
import { USER_SESSION_OVERRIDE_SESSION_STORAGE_KEY } from "./utils/constants";
import { UserSessionOverride } from "./hooks/useUserSessionOverride";
import { GlobalErrorHandler } from "./GlobalErrorHandler";
import { loadLuckyOrange } from "./utils/luckyOrangeLoader";
import { getBranchIdFromPathname, resolveApiBaseUrl } from "./utils/apiBaseUrl";

const initThis = async () => {
  // Load Lucky Orange analytics if configured
  loadLuckyOrange();

  await initI18n();

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 20 * 60 * 1000, // 20 minutes
        retry: (count, err) => {
          const error = err as Response | undefined;
          if (error?.status === 401 || error?.status === 403) {
            return false;
          }
          return count < 3;
        }
      }
    }
  });

  // Set API client token
  OpenAPI.TOKEN = async () => {
    try {
      const { tokens } = await fetchAuthSession();
      return tokens?.idToken?.toString() ?? "";
    } catch (e) {
      return Promise.resolve("");
    }
  };

  const initialBranchId = getBranchIdFromPathname(window.location.pathname);
  OpenAPI.BASE = resolveApiBaseUrl(initialBranchId) || OpenAPI.BASE;

  OpenAPI.HEADERS = async options => {
    const userSessionOverrideStoredValue = window.sessionStorage.getItem(USER_SESSION_OVERRIDE_SESSION_STORAGE_KEY);
    const headers = options.headers || {};
    const userSessionOverride = userSessionOverrideStoredValue
      ? (JSON.parse(userSessionOverrideStoredValue) as UserSessionOverride)
      : undefined;
    if (userSessionOverride?.username && userSessionOverride) {
      return {
        ...headers,
        "X-Username-Override": userSessionOverride.username
      };
    }
    return headers;
  };

  OpenAPI.ENCODE_PATH = path => path;

  GlobalErrorHandler.init();

  // eslint-disable-next-line
  // import i18n from './i18n';

  ReactDOM.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </React.StrictMode>,
    document.getElementById("root")
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  // reportWebVitals();
};
initThis().then();
